import { createFileRoute } from "@tanstack/react-router";
import Blog from "@/pages/Blog";
import { buildPageHead, breadcrumbSchema, faqPageSchema } from "@/lib/seo";

const faqs = [
  {
    question: "What is the Marjohn Robillo blog about?",
    answer:
      "The Marjohn Robillo blog publishes expert insights on AI automation, revenue operations, CRM architecture, n8n workflow orchestration, and Voice AI — the same frameworks Marjohn deploys across 300+ live client systems in the US, Canada, Australia, and the UK.",
  },
  {
    question: "Who should read the Marjohn Robillo blog?",
    answer:
      "Agency founders, operations leaders, RevOps managers, and hiring teams who want to build or scale automated revenue systems using GoHighLevel, HubSpot, n8n, and agentic Voice AI.",
  },
  {
    question: "How often is new content published?",
    answer:
      "New technical blueprints and strategy guides are published regularly, covering CRM architecture, automation engineering, and AI-driven revenue operations.",
  },
];

export const Route = createFileRoute("/blog/")({
  head: () =>
    buildPageHead({
      title: "Insights & Architecture | Marjohn Robillo Blog",
      description:
        "Expert insights on AI automation, revenue operations, and building high-converting systems. Read the latest strategies by Marjohn Robillo.",
      path: "/blog",
      keywords:
        "revenue operations blog, AI automation insights, CRM automation, GoHighLevel tips, n8n workflows, RevOps strategies, conversion optimization, technical VA guide, Philippines automation expert, Marjohn Robillo blog",
      schema: [
        breadcrumbSchema([
          { name: "Home", path: "" },
          { name: "Blog", path: "/blog" },
        ]),
        faqPageSchema(faqs),
      ],
    }),
  component: Blog,
});
